import { notifUtils } from "../components/NotifUtils/NotifUtils";
import { handleError } from "../components/Utils/Utils";
import CategoryService from "../Services/Category/CategoryService";

export const get = (store, value) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status });
  return CategoryService.getData(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const lastPage = false;
      const status = data.message;
      store.setState({
        isLoading,
        data,
        header: response.headers,
        lastPage,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const getModulelist = (store) => {
  CategoryService.getModule()
    .then((response) => {
      let data = response.data;
      store.setState({
        module: data,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const getList = (store, value, refresh) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status, refresh });
  CategoryService.getData(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const status = data.message;
      store.state.lastPage = false;
      store.state.data = refresh ? data : store.state.data.concat(data);
      if (data.length < parseInt(value.num)) {
        store.state.lastPage = true;
      }
      store.setState({
        isLoading,
        header: response.headers,
        status,
        refresh: false,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const store = async (store, value) => {
  try {
    const response = await CategoryService.storeData(value);
    const data = response.data;
    notifUtils("Successfully Created Category", "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const put = async (store, value, index) => {
  try {
    const response = await CategoryService.putData(value);
    const data = response.data;
    notifUtils("Successfully Updated Category", "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const deleted = async (store, query) => {
  try {
    const response = await CategoryService.deleteData(query);
    const data = response.data;
    notifUtils("Successfully Deleted User", "success");
    return data;
  } catch (error) {
    handleError(error);
    return false;
  }
};
